import { render } from "./OperationsClientDetails.vue?vue&type=template&id=4d549698&scoped=true"
import script from "./OperationsClientDetails.vue?vue&type=script&lang=js"
export * from "./OperationsClientDetails.vue?vue&type=script&lang=js"

import "./OperationsClientDetails.vue?vue&type=style&index=0&id=4d549698&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d549698"]])

export default __exports__